/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { useContext, useState } from 'react'
import { Button } from '@livechat/design-system'
import addIcon from '../assets/icons/blue-add.svg'

import { Context } from '../context'
import api from '../api'
import { Heading } from './'

import AddConnection from './AddConnection'
import ChatAttributes from './ChatAttributes'

const containerCss = css`
  height: 100%;
  margin-top: 10px;
  overflow: scroll;
  cursor: default;

  .lc-btn {
    padding: 6px 12px;

    > div {
      display: flex;
      align-items: center;
    }
  }
`

const boxCss = (isTall) => css`
  border-radius: 4px;
  background-color: white;
  padding: 15px;
  box-shadow: rgb(228 228 228) 0px 1px 5px 0px;
  margin-bottom: 10px;

  min-height: 85px;

  ${isTall &&
  css`
    min-height: 150px;
  `}
`

const infoCss = css`
  color: gray;
  font-weight: 300;
`

const SurveyConnections = ({ survey }) => {
  const { surveyToken, switchSavingAttributes } = useContext(Context)
  const [switchDisabled, setSwitchDisabled] = useState(false)

  const onAttributesChange = async () => {
    setSwitchDisabled(true)
    if (survey.isSettingAttributes) {
      // TODO: Add loading state
      switchSavingAttributes(survey.id, false)
      await api.deactivateSavingAttributes(survey.id, surveyToken)
    } else {
      switchSavingAttributes(survey.id, true)
      await api.activateSavingAttributes(survey.id, surveyToken)
    }
    setSwitchDisabled(false)
  }

  return (
    <div css={containerCss}>
      <div css={boxCss()}>
        <Heading
          label="Chat attributes"
          info="Start saving customers response as chat attributes."
        />
        <ChatAttributes
          survey={survey}
          onChange={onAttributesChange}
          status={survey.isSettingAttributes}
          disabled={switchDisabled}
        />
      </div>
      <div css={boxCss()}>
        <Heading
          label="Webhooks"
          info="Enable your external service to recive your customers response."
        />

        <AddConnection survey={survey} />
      </div>
    </div>
  )
}

export default SurveyConnections
